import { createAppSearchState } from "../types/app-search.functions";
import { AppSearchActions, AppSearchActionType } from "./app-search.actions";

export const appSearchReducer = (state = createAppSearchState(), action: AppSearchActionType) => {
  switch (action.type) {
    case AppSearchActions.Clear:
      return createAppSearchState();

    case AppSearchActions.Search:
      return {
        ...state,
        errors: null,
        loaded: false,
        loading: true,
        pagination: null,
        results: {},
      };

    case AppSearchActions.SearchFailure:
      return {
        ...state,
        errors: action.payload,
        loaded: true,
        loading: false,
        pagination: null,
        results: {},
      };

    case AppSearchActions.SearchSuccess:
      const { pagination, ...results } = action.payload;
      return {
        ...state,
        errors: null,
        loaded: true,
        loading: false,
        pagination,
        results,
      };

    default:
      return state;
  }
};
